import { Link } from "@tanstack/react-router";

export function Footer() {
  return (
    <footer className="border-t border-border bg-ivory">
      <div className="mx-auto max-w-7xl px-6 py-12 grid gap-10 sm:grid-cols-3 text-sm text-ink-secondary">
        <div>
          <p className="overline mb-2">Tiger&apos;s Eye Academic Review</p>
          <p className="max-w-xs">
            Impartial academic draft review. Clear critique. No false promises.
            Tiger&apos;s Eye does not write, rewrite, predict grades, or help bypass academic
            integrity rules.
          </p>
        </div>
        <div>
          <p className="overline mb-2">What we review</p>
          <p className="max-w-xs">
            Structure, argument, clarity, evidence
            <br />Referencing, citation gaps, bibliography
            <br />Academic integrity risks - flagged neutrally
          </p>
        </div>
        <div>
          <p className="overline mb-2">Policy &amp; disclaimers</p>
          <ul className="space-y-1">
            <li>
              <Link to="/terms" className="hover:text-primary underline underline-offset-4">
                Terms, waiver &amp; disclaimer
              </Link>
            </li>
            <li className="text-ink-tertiary">
              Student remains solely responsible for submitted work.
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-ink-tertiary">
        © {new Date().getFullYear()} Tiger&apos;s Eye Academic Review · A PRAXIA initiative
      </div>
    </footer>
  );
}
